import { ViBrandApi } from './vi-brand.api.model';
import { ViCompetitorApi } from './vi-competitor.api.model';
import { ViDimensionEnum } from '../../../VisibilityIntelligence/enums/vi-dimension.enum';
import { ViQuestionApi } from './vi-question.api.model';


export interface ViQuestionDimensionCountsApi {
    brandIdentityCount: number;
    productsAndServicesCount: number;
    customerExperienceCount: number;
    topicalAuthorityCount: number;
    misinformationRiskCount: number;
    competitivePositioningCount: number;
}

export const DIMENSION_PROPERTY_MAP: Record<ViDimensionEnum, keyof ViQuestionDimensionCountsApi> = {
    [ViDimensionEnum.brandIdentity]:          'brandIdentityCount',
    [ViDimensionEnum.productsAndServices]:    'productsAndServicesCount',
    [ViDimensionEnum.customerExperience]:     'customerExperienceCount',
    [ViDimensionEnum.topicalAuthority]:       'topicalAuthorityCount',
    [ViDimensionEnum.misinformationRisk]:     'misinformationRiskCount',
    [ViDimensionEnum.competitivePositioning]: 'competitivePositioningCount',
};

export function buildDimensionCounts(dimensions: { key: ViDimensionEnum; count: number }[]): ViQuestionDimensionCountsApi {
    return dimensions.reduce((counts, dimension) => {
        counts[DIMENSION_PROPERTY_MAP[dimension.key]] = dimension.count ?? 0;
        return counts;
    }, {} as ViQuestionDimensionCountsApi);
}

export interface ViGenerateQuestionsRequestApi {
    questions?: ViQuestionApi[];
    brandInfo: ViBrandApi;
    competitors?: ViCompetitorApi[];
    targetKeywords: string[];
    language?: string;
    dimensionCounts: ViQuestionDimensionCountsApi;
}

export interface ViGenerateQuestionsResponseApi {
    questions: ViQuestionApi[];
    modelUsed: string;
}
